// You can write your custom Javascript here
(function ($) {
  $(document).ready(function () {

    
    function productImages() {
      var matchArray = [];
      $(".single-option-selector").each(function () {
        matchArray.push($(this).val());
      });
      var matchString = matchArray.join(" / ");
      var selectedId = "";
      $("#product-select")
        .find("option")
        .each(function () {
          if ($(this).text() == matchString) {
            selectedId = $(this).attr("value");
          }
        });

      const url = new URL(window.location);
      let productTemplate = $("body.template-product");
      if (productTemplate.length > 0) {
        url.searchParams.set("variant", selectedId);
        window.history.pushState({}, "", url);
      }

      var bigTarget = $(".product__slider [data-otherimages]");
      var smallTarget = $(".product__thumbs [data-otherimages]");

      
    if (bigTarget.length === 0 || !bigTarget.attr("data-otherimages") ||
        smallTarget.length === 0 || !smallTarget.attr("data-otherimages")) {
        console.log("bigTarget or smallTarget is not properly defined. Exiting productImages function.");
        return; 
    }

    var bigArray = bigTarget.attr("data-otherimages").split(",");
    var smallArray = smallTarget.attr("data-otherimages").split(",");

      var structured = [];

      for (i = 0; i < bigArray.length; i++) {
        var bufferBigArray = bigArray[i].split(":");
        var bufferSmallArray = smallArray[i].split(":");

        var bufferObject = {
          id: bufferBigArray[0],
          bigSrc: bufferBigArray[1],
          smallSrc: bufferSmallArray[1],
        };
        structured.push(bufferObject);
      }

      var selectedObj = structured.filter((obj) => {
        return obj.id === selectedId;
      });

      selectedObj = selectedObj[0];

      bigTarget.find("img").attr("src", selectedObj.bigSrc);
      smallTarget.find("img").attr("src", selectedObj.smallSrc);
    }

    $(".single-option-selector").on("change", function () {
      productImages();
    });

    $(window).on("load scroll", function () {
      //console.log($(this).scrollTop())
      if ($(this).scrollTop() < 10) {
        productImages();
      }
      productImages();
      const url = new URL(window.location);
      const urlVariant = url.searchParams.get("variant");
    });

    $(".template-cart .modalButton").on("click", function () {
      $(".modal").fadeIn();
    });

    $(".template-cart .modal__close").on("click", function () {
      $(".modal").fadeOut();
    });


  });
})(jQuery);

// Move Klaviyo's back in stock button to replace "Sold Out" button

setInterval(function () {
  let klaviyoBIS_ready = jQuery(".klaviyo-bis-trigger");
  if (klaviyoBIS_ready.length) {
    jQuery(".template-product .bis-replace").after(klaviyoBIS_ready);
    jQuery(
      ".template-product .bold_clone.bis-replace, .template-product .addtocart.bis-replace"
    ).remove();
    jQuery(".template-product .klaviyo-bis-trigger").addClass("bis-replace");
    return false;
  }
  console.log(klaviyoBIS_ready.length);
  if (klaviyoBIS_ready.length > 1) {
    jQuery(".template-product .bis-replace").first().remove();
  }
}, 1000);



  jQuery(document).ready(function($) {

/******************************************
    Modals
  ******************************************/

  // Launch the modal
  $(".videosList .btn--modal").on("click", function (e) {
    e.preventDefault();
    var modalID = "#" + $(this).attr("data-modal");
    console.log(modalID);

    if ($(this)[0].hasAttribute("data-video-yt")) {
      var videoID = $(this).attr("data-video-yt");
      $(modalID)
        .find(".modal__inner")
        .append(
          '<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' +
            videoID +
            '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>'
        );
    }

    if ($(this)[0].hasAttribute("data-video-vimeo")) {
      var videoID = $(this).attr("data-video-vimeo");
      $(modalID)
        .find(".modal__inner")
        .append(
          '<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' +
            videoID +
            '"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>'
        );
    }

    $(modalID).fadeIn("fast");
  });

  // Close the modal
  $(".modal--close, .modal__bg").on("click", function (e) {
    closeModal($(this));
  });

  
function closeModal(object) {
  object.closest(".modal").fadeOut("fast", function () {
    $(".modal__inner .iframe-wrap").remove();
  });
}

    
      });

// gorgias chat custom

$(window).on('load', function() {
  $("#gorgias-chat-container iframe#chat-button").css("z-index", "50");
  $("#gorgias-chat-container iframe#chat-window").css("z-index", "50");
});